import React, { useState, useEffect } from "react";
import T from "./TheTool";
import Timer from "./TheTimer";
import Template from "./TheTemplate";
import GUIset_2Input from "./gui/GUIset_2Input";

const Multiply = () => {
	useEffect(() => {
		document.title =
			"Subarray with given multiplication: which number in a list multiply to a certain number?";
	}, []);

	const [guiTxt1, guiTxtChange1] = useState("60"); //int
	const [guiTxt2, guiTxtChange2] = useState(
		"20,12,7,8,2,4,3,40,9,56,48,23,5,64,8,10"
	);
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const buttonClick1 = () => {
		if (guiTxt1 != "" && guiTxt2 != "") {
			var target0 = parseInt(guiTxt1);
			var arr0 = T.str_toListInt(guiTxt2);
			//----------------------
			Timer.setTimeBudget(4999);
			Timer.start();
			process(target0, arr0);
			txt_time = Timer.stop_print();
			//--------------------------
			BuildResult();
			arr = []; //only multiplicable
			list_solution = [];
		}
	};

	var txt_time = "";
	var n_set = 0;
	var arr = []; //only multiplicable
	var list_solution = [];
	var min_n = 0;

	function process(target0, arr0) {
		list_solution = [];
		min_n = 0;
		generateArr(target0, arr0);
		findItem([], target0, 0);
		n_set = list_solution.length;
	}

	function generateArr(target0, arr0) {
		arr = [];
		for (var i = 0; i < arr0.length; i++) {
			if (target0 % arr0[i] == 0) {
				arr.push(arr0[i]);
			}
		}
		console.log("Arr " + arr);
	}

	function findItem(list, remain, i) {
		if (Timer.timeout()) {
			return;
		}
		//-------------------------------
		if (remain == 1) {
			// console.log("XXX ");
			if (min_n == 0 || list.length < min_n) {
				min_n = list.length;
			}
			list_solution.push(list);
			console.log("FOUND " + list);
		} else if (remain > 1 && i < arr.length) {
			// console.log("YYY ");
			var x = arr[i];
			var list_new = T.listAdd(list, x);
			findItem(list_new, remain / x, i + 1); //add
			findItem(list, remain, i + 1); //skip
		}
	}

	//-------------------------

	function BuildResult() {
		var txt = "";
		var txt3 = "";
		var part1 = [<div></div>];
		var part2 = [<div></div>];
		var txtHead = "Subarray";
		//------------------------
		txt += txt_time;
		txt += Timer.reachLimit() ? " (limited)\n" : "\n";
		if (n_set < 1) {
			txt += "No possible subarray";
		} else {
			txt += "Divisors: " + arr + "\n";
			if (n_set == 1) {
				txt += "Possible subarray: 1";
			} else {
				txt += "Possible subarrays: " + n_set;
				txtHead += "s";
			}
			// txtHead += " with the smallest number of elements";
			txt3 = "[" + list_solution.join("]\n[") + "]";
			txt3 = txt3 == "" ? "[ ]" : txt3;
			txt += "\nMinimum Length: " + min_n;
			part2 = Template.simple00("key2", 1, txtHead, txt3, 22, 20);
		}
		part1 = Template.simple01("key1", "Result", txt, 20, 22);
		partResultChange(
			<div>
				{part1}
				<br />
				{part2}
			</div>
		);
	}

	return (
		<GUIset_2Input
			title={"Subarray with given multiplication"}
			desc={
				"How many subsets can multiply to a certain number? (Find sets/arrays of numbers that multiply to a given value)."
			}
			guiTxtChange1={guiTxtChange1}
			guiTxtChange2={guiTxtChange2}
			buttonClick1={buttonClick1}
			partResult={partResult}
			//------
			label1={"Target"}
			label2={"Items"}
			guiTxt1={guiTxt1}
			guiTxt2={guiTxt2}
			numberOnly1={true}
			numberOnly2={false}
			txtButton={"Calculate"}
			style={1}
		/>
	);
};

export default Multiply;

// import GUI_Header from "./gui/GUI_Header";
// import GUI_InputTextSingle from "./gui/GUI_InputTextSingle";
// import GUI_Credit from "./gui/GUI_Credit";
// import T from "./TheTool";// NOT WORK, old ver

// part2 = [
// 	<div key="part2">
// 		<br />
// 		<div style={{ whiteSpace: "pre-line", fontSize: 20 }}>
// 			<b>{txtHead}</b>
// 		</div>
// 		<div style={{ whiteSpace: "pre-line", fontSize: 20 }}>{txt3}</div>
// 	</div>,
// ];
// part1 = [
// 	<div key="part1">
// 		<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>
// 			<h2>Result</h2>
// 		</div>
// 		<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>{txt}</div>
// 	</div>,
// ];

// return (
// 	<div className="todoapp stack-large">
// 		<GUI_Header
// 			title={"Subarray with given multiplication"}
// 			desc={
// 				"How many subsets can multiply to a certain number? (Find sets/arrays of numbers that multiply to a given value)."
// 			}
// 		/>
// 		<div style={{ marginTop: "3em" }}> </div>
// 		<GUI_InputTextSingle
// 			label={"Target"}
// 			text1={guiTxt1}
// 			text1Change={guiTxtChange1}
// 			numberOnly={true}
// 			fontSize2={28}
// 			width1={120}
// 			width2={'80%'}
// 		/>
// 		<GUI_InputTextSingle
// 			label={"Items"}
// 			text1={guiTxt2}
// 			text1Change={guiTxtChange2}
// 			numberOnly={false}
// 			fontSize2={24}
// 			width1={120}
// 			width2={'80%'}
// 		/>
// 		<div style={{ display: "flex", marginLeft: '20%', marginRight: '2%'  }}>
// 			<button
// 				onClick={() => buttonClick1()}
// 				className="btn btn__primary btn__lg"
// 				style={{ flex: 1, height: 50 }}
// 			>
// 				Calculate
// 			</button>
// 		</div>
// 		<div style={{ marginTop: "3em" }}> </div>
// 		{partResult}
// 		{/* {GetResult()} */}
// 		<GUI_Credit />
// 	</div>
// );
// };
